module.exports = __webpack_public_path__ + "static/media/main4.36d995af.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/bizhengImg/main4.png
// module id = 1868
// module chunks = 1